import { apiSlice } from "../api/apiSlice";

const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: (email) => `/teams?members_like=${email}`,
    }),
    addTeam: builder.mutation({
      query: ({ data }) => ({
        url: "/teams",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;
        const { data: team } = response;
        dispatch(
          apiSlice.util.updateQueryData("getTeams", team.creator, (draft) => {
            draft.push(team);
          })
        );
      },
    }),
    addMember: builder.mutation({
      query: ({ id, data, user }) => ({
        url: `/teams/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted({ user }, { queryFulfilled, dispatch }) {
        console.log(user);
        const response = await queryFulfilled;
        const { data: team } = response;
        dispatch(
          apiSlice.util.updateQueryData("getTeams", user?.email, (draft) => {
            return draft.map((item) => {
              if (item.id === team.id) {
                return {
                  ...item,
                  members: team.members,
                };
              }
              return item;
            });
          })
        );
      },
    }),
  }),
});

export const { useGetTeamsQuery, useAddTeamMutation, useAddMemberMutation } =
  teamsApi;
